import { motion } from 'framer-motion';
import { SERVICES } from '@/lib/index';

const colorMap: Record<string, string> = {
  primary: 'var(--primary)',
  accent: 'var(--accent)',
  'chart-3': 'var(--chart-3)',
  'chart-4': 'var(--chart-4)',
  'chart-5': 'var(--chart-5)',
};

export function ServicesSection() {
  return (
    <section id="services" className="py-24 px-6 relative">
      <div
        className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-px"
        style={{ background: 'linear-gradient(to right, transparent, var(--accent), transparent)' }}
      />

      <div className="max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-14"
        >
          <p className="text-xs font-mono text-accent uppercase tracking-widest mb-3">What I Do</p>
          <h2 className="text-4xl md:text-5xl font-bold text-foreground mb-4">Services</h2>
          <p className="text-muted-foreground max-w-xl mx-auto">
            From intimate solo works to full orchestral scores — every project receives the same
            level of craft and dedication.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))' }}>
          {SERVICES.map((service, i) => {
            const accent = colorMap[service.color] ?? 'var(--primary)';
            return (
              <motion.div
                key={service.title}
                initial={{ opacity: 0, y: 32 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                whileHover={{ y: -4 }}
                className="rounded-2xl border border-border bg-card/60 backdrop-blur-sm p-6 flex flex-col gap-4 transition-all duration-200"
                style={{
                  borderTopColor: accent,
                  borderTopWidth: '2px',
                  boxShadow: `0 8px 30px -6px ${accent}22`,
                }}
              >
                <div
                  className="w-12 h-12 rounded-xl flex items-center justify-center text-2xl"
                  style={{ background: `${accent}22` }}
                >
                  {service.icon}
                </div>
                <div>
                  <h3 className="font-bold text-lg text-foreground mb-2">{service.title}</h3>
                  <p className="text-sm text-muted-foreground leading-relaxed">
                    {service.description}
                  </p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
